import React from 'react';

const Footer = () => {
  return (
    <footer>
      <p>© 2024 - Grocery Guardians, Inc. All rights reserved.</p>
      <p>Diana Tran | Militha Madur | Mercedes Ro | Sonia Yeh</p>
    </footer>
  );
};

export default Footer;
